﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tinycolor from 'tinycolor';

import tpl_eventImagePrintTemplate from '../tplRender/eventImagePrintTemplate.html';
import tpl_eventTemplate from '../tplRender/eventTemplate.html';
import tpl_eventSchemaTemplate from '../tplRender/eventSchemaTemplate.html';
import tpl_eventProductSheetTemplate from '../tplRender/eventProductSheetTemplate.html';
import tpl_eventSchemaBigscreenTemplate from '../tplRender/eventSchemaBigscreenTemplate.html';
import tpl_eventFormTemplate from '../tplRender/eventFormTemplate.html';
import tpl_eventInfoTemplate from '../tplRender/eventInfoTemplate.html';
import tpl_eventPosterTemplate from '../tplRender/eventPosterTemplate.html';
import tpl_eventQRTemplate from '../tplRender/eventQRTemplate.html';
import tpl_eventLocationTemplate from '../tplRender/eventLocationTemplate.html';
import tpl_eventCalendarTemplate from '../tplRender/eventCalendarTemplate.html';

import tpl_eventIndexTemplate from '../tplRender/eventIndexTemplate.html';
import tpl_eventIndexImagePrintTemplate from '../tplRender/eventIndexImagePrintTemplate.html';

import * as Entities_Event from '../entities/event';
import * as Entities_Empty from '../../lib/entities/empty';
import * as Entities_AzureEvent from '../entities/azureEvent';
import * as Entities_Page2Image from '../entities/page2image';
import * as Entities_QRCode from '../entities/qrcode';

import * as Entities_Header from '../../event/entities/header';

import * as Entities_Memory from '../entities/memory';
import * as Entities_Memory_Position from '../entities/memoryPosition';

import config from '../../common/config';
import renderError from './renderError';

var HelperInfopage = {
    getStyleSheet: function (unique_title) {
        for (var i = 0; i < document.styleSheets.length; i++) {
            var sheet = document.styleSheets[i];
            if (sheet.title == unique_title) {
                return sheet;
            }
        }
    },
    getRuleIndex: function (style, className) {
        var ret = -1;

        for (var i = 0; i < style.cssRules.length; i++) {
            var cssRule = style.cssRules[i].selectorText;
            if (style.cssRules[i].selectorText == className) {
                ret = i;
            }
        }

        return ret;
    },
    setupCssStyle: function (app) {
        var style = this.getStyleSheet('infopage');
        var cssRulesIdx = this.getRuleIndex(style, '.infopage > h2');
        if (cssRulesIdx != -1) {
            style.deleteRule(cssRulesIdx);

            var font1_style = app.entities.collections.FontStyle.where({
                Value: app.entities.models.InfoPageSetting.attributes.Font1_Style
            });

            var font1_color = app.entities.models.InfoPageSetting.attributes.Font1_Color;
            /*switch (app.entities.models.InfoPageSetting.attributes.Font1_ColorType) {
                case "0": font1_color = app.entities.models.InfoPageSetting.attributes.Font1_ColorApp; break;
                case "1": font1_color = app.entities.models.InfoPageSetting.attributes.Font1_Color; break;
            }*/

            var font1_lineHeight = app.entities.collections.LineHeight.where({
                Value: app.entities.models.InfoPageSetting.attributes.Font1_LineHeight
            });

            var font1 = app.entities.models.InfoPageSetting.attributes.Font1;
            switch (app.entities.models.InfoPageSetting.attributes.Font1_FontType) {
                case "0": font1 = app.entities.models.InfoPageSetting.attributes.Font1_App; break;
                case "1": font1 = app.entities.models.InfoPageSetting.attributes.Font1; break;
            }

            var rule = String.format(".infopage > h2 {font-family:{0};font-size:{1};color:{2};{3};{4} }",
                font1,
                app.entities.models.InfoPageSetting.attributes.Font1_Size,
                font1_color,
                font1_lineHeight[0].attributes.Style,
                font1_style[0].attributes.Style);
            style.insertRule(rule);
        }
        var cssRulesIdx = this.getRuleIndex(style, '.infopage > h3');
        if (cssRulesIdx != -1) {
            style.deleteRule(cssRulesIdx);

            var font2_style = app.entities.collections.FontStyle.where({
                Value: app.entities.models.InfoPageSetting.attributes.Font2_Style
            });

            var font2_color = app.entities.models.InfoPageSetting.attributes.Font2_Color;
            /*switch (app.entities.models.InfoPageSetting.attributes.Font2_ColorType) {
                case "0": font2_color = app.entities.models.InfoPageSetting.attributes.Font2_ColorApp; break;
                case "1": font2_color = app.entities.models.InfoPageSetting.attributes.Font2_Color; break;
            }*/

            var font2_lineHeight = app.entities.collections.LineHeight.where({
                Value: app.entities.models.InfoPageSetting.attributes.Font2_LineHeight
            });

            var font2 = app.entities.models.InfoPageSetting.attributes.Font2;
            switch (app.entities.models.InfoPageSetting.attributes.Font2_FontType) {
                case "0": font2 = app.entities.models.InfoPageSetting.attributes.Font2_App; break;
                case "1": font2 = app.entities.models.InfoPageSetting.attributes.Font2; break;
            }


            var rule = String.format(".infopage > h3 {font-family:{0};font-size:{1};color:{2};{3};{4} }",
                font2,
                app.entities.models.InfoPageSetting.attributes.Font2_Size,
                font2_color,
                font2_lineHeight[0].attributes.Style,
                font2_style[0].attributes.Style);
            style.insertRule(rule);
        }
        var cssRulesIdx = this.getRuleIndex(style, '.infopage > h4');
        if (cssRulesIdx != -1) {
            style.deleteRule(cssRulesIdx);

            var font3_style = app.entities.collections.FontStyle.where({
                Value: app.entities.models.InfoPageSetting.attributes.Font3_Style
            });

            var font3_color = app.entities.models.InfoPageSetting.attributes.Font3_Color;
            /*switch (app.entities.models.InfoPageSetting.attributes.Font3_ColorType) {
                case "0": font3_color = app.entities.models.InfoPageSetting.attributes.Font3_ColorApp; break;
                case "1": font3_color = app.entities.models.InfoPageSetting.attributes.Font3_Color; break;
            }*/

            var font3_lineHeight = app.entities.collections.LineHeight.where({
                Value: app.entities.models.InfoPageSetting.attributes.Font3_LineHeight
            });

            var font3 = app.entities.models.InfoPageSetting.attributes.Font3;
            switch (app.entities.models.InfoPageSetting.attributes.Font3_FontType) {
                case "0": font3 = app.entities.models.InfoPageSetting.attributes.Font3_App; break;
                case "1": font3 = app.entities.models.InfoPageSetting.attributes.Font3; break;
            }

            var rule = String.format(".infopage > h4 {font-family:{0};font-size:{1};color:{2};{3};{4} }",
                font3,
                app.entities.models.InfoPageSetting.attributes.Font3_Size,
                font3_color,
                font3_lineHeight[0].attributes.Style,
                font3_style[0].attributes.Style);
            style.insertRule(rule);
        }
        var cssRulesIdx = this.getRuleIndex(style, '.infopage > p');
        if (cssRulesIdx != -1) {
            style.deleteRule(cssRulesIdx);

            var font4_style = app.entities.collections.FontStyle.where({
                Value: app.entities.models.InfoPageSetting.attributes.Font4_Style
            });

            var font4_color = app.entities.models.InfoPageSetting.attributes.Font4_Color;
            /*switch (app.entities.models.InfoPageSetting.attributes.Font4_ColorType) {
                case "0": font4_color = app.entities.models.InfoPageSetting.attributes.Font4_ColorApp; break;
                case "1": font4_color = app.entities.models.InfoPageSetting.attributes.Font4_Color; break;
            }*/

            var font4_lineHeight = app.entities.collections.LineHeight.where({
                Value: app.entities.models.InfoPageSetting.attributes.Font4_LineHeight
            });

            var font4 = app.entities.models.InfoPageSetting.attributes.Font4;
            switch (app.entities.models.InfoPageSetting.attributes.Font4_FontType) {
                case "0": font4 = app.entities.models.InfoPageSetting.attributes.Font4_App; break;
                case "1": font4 = app.entities.models.InfoPageSetting.attributes.Font4; break;
            }

            var rule = String.format(".infopage > p {font-family:{0};font-size:{1};color:{2};{3};{4} }",
                font4,
                app.entities.models.InfoPageSetting.attributes.Font4_Size,
                font4_color,
                font4_lineHeight[0].attributes.Style,
                font4_style[0].attributes.Style);
            style.insertRule(rule);
        }

        this.setupModels(app);
    },
    setupModels: function (app) {

    },
    updateFontFromNewModule: function (eventId, ModuleType, data) {
        var tmpSelectedModelSetting_11 = app.entities.collections.customModule.where({ EventId: eventId, ModuleType: ModuleType })[0];
        var data_11 = JSON.parse(tmpSelectedModelSetting_11.attributes.Data);
        var modelSetting_11 = new Entities_Memory.Model(data_11[0].Data);

        var model = new Entities_Memory.Model(data);

        if (model.attributes.Font1_FontType != undefined) {
            switch (model.attributes.Font1_FontType) {
                case "0": model.attributes.Font1 = modelSetting_11.attributes.Font1; break;
                case "1": model.attributes.Font1 = modelSetting_11.attributes.Font2; break;
                case "2": model.attributes.Font1 = modelSetting_11.attributes.Font3; break;
                case "3": model.attributes.Font1 = modelSetting_11.attributes.Font4; break;
            }
        }

        if (model.attributes.Font2_FontType != undefined) {
            switch (model.attributes.Font2_FontType) {
                case "0": model.attributes.Font2 = modelSetting_11.attributes.Font1; break;
                case "1": model.attributes.Font2 = modelSetting_11.attributes.Font2; break;
                case "2": model.attributes.Font2 = modelSetting_11.attributes.Font3; break;
                case "3": model.attributes.Font2 = modelSetting_11.attributes.Font4; break;
            }
        }

        if (model.attributes.Font3_FontType != undefined) {
            switch (model.attributes.Font3_FontType) {
                case "0": model.attributes.Font3 = modelSetting_11.attributes.Font1; break;
                case "1": model.attributes.Font3 = modelSetting_11.attributes.Font2; break;
                case "2": model.attributes.Font3 = modelSetting_11.attributes.Font3; break;
                case "3": model.attributes.Font3 = modelSetting_11.attributes.Font4; break;
            }
        }

        if (model.attributes.Font1_ColorType != undefined) {
            switch (model.attributes.Font1_ColorType) {
                case "0": model.attributes.Font1_Color = modelSetting_11.attributes.Font1_Color; break;
                case "1": model.attributes.Font1_Color = modelSetting_11.attributes.Font2_Color; break;
                case "2": model.attributes.Font1_Color = modelSetting_11.attributes.Font3_Color; break;
                case "3": model.attributes.Font1_Color = modelSetting_11.attributes.Font4_Color; break;
            }
        }

        if (model.attributes.Font2_ColorType != undefined) {
            switch (model.attributes.Font2_ColorType) {
                case "0": model.attributes.Font2_Color = modelSetting_11.attributes.Font1_Color; break;
                case "1": model.attributes.Font2_Color = modelSetting_11.attributes.Font2_Color; break;
                case "2": model.attributes.Font2_Color = modelSetting_11.attributes.Font3_Color; break;
                case "3": model.attributes.Font2_Color = modelSetting_11.attributes.Font4_Color; break;
            }
        }

        if (model.attributes.Font3_ColorType != undefined) {
            switch (model.attributes.Font3_ColorType) {
                case "0": model.attributes.Font3_Color = modelSetting_11.attributes.Font1_Color; break;
                case "1": model.attributes.Font3_Color = modelSetting_11.attributes.Font2_Color; break;
                case "2": model.attributes.Font3_Color = modelSetting_11.attributes.Font3_Color; break;
                case "3": model.attributes.Font3_Color = modelSetting_11.attributes.Font4_Color; break;
            }
        }

        var ret = model.toJSON();

        return ret;
    },
    updateFontFromInfopage: function (eventId, ModuleType, app, modelSetting, callback) {
        //var data_11 = JSON.parse(modelSetting.attributes.Data);
        //var modelSetting_11 = new Entities_Memory.Model(data_11[0].Data);


        var model = app.entities.collections.customModule.where({ EventId: eventId, ModuleType: ModuleType })[0];
        var data = JSON.parse(model.attributes.Data)[0];
        var collection = new Entities_Memory_Position.Collection(data.Collection);
        collection.forEach(function (entry) {
            var webpage_collection = new Entities_Memory_Position.Collection(entry.attributes.Collection);
            webpage_collection.forEach(function (webpage_collection_model) {
                if (webpage_collection_model.attributes.Data != undefined) {
                    if (!jQuery.isEmptyObject(webpage_collection_model.attributes.Data)) {
                        var model = new Entities_Memory.Model(webpage_collection_model.attributes.Data);

                        if (model.attributes.Font1_FontType != undefined) {
                            switch (model.attributes.Font1_FontType) {
                                case "0": model.attributes.Font1 = modelSetting.attributes.Font1; break;
                                case "1": model.attributes.Font1 = modelSetting.attributes.Font2; break;
                                case "2": model.attributes.Font1 = modelSetting.attributes.Font3; break;
                                case "3": model.attributes.Font1 = modelSetting.attributes.Font4; break;
                            }
                        }

                        if (model.attributes.Font2_FontType != undefined) {
                            switch (model.attributes.Font2_FontType) {
                                case "0": model.attributes.Font2 = modelSetting.attributes.Font1; break;
                                case "1": model.attributes.Font2 = modelSetting.attributes.Font2; break;
                                case "2": model.attributes.Font2 = modelSetting.attributes.Font3; break;
                                case "3": model.attributes.Font2 = modelSetting.attributes.Font4; break;
                            }
                        }

                        if (model.attributes.Font3_FontType != undefined) {
                            switch (model.attributes.Font3_FontType) {
                                case "0": model.attributes.Font3 = modelSetting.attributes.Font1; break;
                                case "1": model.attributes.Font3 = modelSetting.attributes.Font2; break;
                                case "2": model.attributes.Font3 = modelSetting.attributes.Font3; break;
                                case "3": model.attributes.Font3 = modelSetting.attributes.Font4; break;
                            }
                        }

                        if (model.attributes.Font1_ColorType != undefined) {
                            switch (model.attributes.Font1_ColorType) {
                                case "0": model.attributes.Font1_Color = modelSetting.attributes.Font1_Color; break;
                                case "1": model.attributes.Font1_Color = modelSetting.attributes.Font2_Color; break;
                                case "2": model.attributes.Font1_Color = modelSetting.attributes.Font3_Color; break;
                                case "3": model.attributes.Font1_Color = modelSetting.attributes.Font4_Color; break;
                            }
                        }

                        if (model.attributes.Font2_ColorType != undefined) {
                            switch (model.attributes.Font2_ColorType) {
                                case "0": model.attributes.Font2_Color = modelSetting.attributes.Font1_Color; break;
                                case "1": model.attributes.Font2_Color = modelSetting.attributes.Font2_Color; break;
                                case "2": model.attributes.Font2_Color = modelSetting.attributes.Font3_Color; break;
                                case "3": model.attributes.Font2_Color = modelSetting.attributes.Font4_Color; break;
                            }
                        }

                        if (model.attributes.Font3_ColorType != undefined) {
                            switch (model.attributes.Font3_ColorType) {
                                case "0": model.attributes.Font3_Color = modelSetting.attributes.Font1_Color; break;
                                case "1": model.attributes.Font3_Color = modelSetting.attributes.Font2_Color; break;
                                case "2": model.attributes.Font3_Color = modelSetting.attributes.Font3_Color; break;
                                case "3": model.attributes.Font3_Color = modelSetting.attributes.Font4_Color; break;
                            }
                        }

                        //var savedata_1 = [{ Data: model.attributes }];
                        //var strJson_1 = JSON.stringify(savedata_1);
                        //webpage_collection_model.attributes.Data = strJson_1;
                        webpage_collection_model.attributes.Data = model.attributes;
                    }
                }
            });

            /*var savedata_collection = [{ Collection: webpage_collection }];
            var strJson_collection = JSON.stringify(savedata_collection);
            entry.attributes.Collection = strJson_collection;*/
            entry.attributes.Collection = webpage_collection.toJSON();
        });

        var data = [{ Collection: collection }];
        var strJson = JSON.stringify(data);
        model.attributes.Data = strJson;

        app.entities.collections.customModule.where({ EventId: eventId, ModuleType: ModuleType })[0].save(model.attributes, {
            silent: false,
            wait: true,
            success: function () {
                callback();
            }
        });
    },
    updateFontFromAppSetting(selectedModelSetting, eventId, ModuleType) {
        var tmpSelectedModelSetting_11 = app.entities.collections.customModule.where({ EventId: eventId, ModuleType: ModuleType })[0];
        var data_11 = JSON.parse(tmpSelectedModelSetting_11.attributes.Data);
        var selectedModelSetting_11 = new Entities_Memory.Model(data_11[0].Data);

        selectedModelSetting_11.attributes.Font1_App = selectedModelSetting.attributes.Font1;
        selectedModelSetting_11.attributes.Font1_ColorApp = selectedModelSetting.attributes.Font1_Color;
        selectedModelSetting_11.attributes.Font2_App = selectedModelSetting.attributes.Font1;
        selectedModelSetting_11.attributes.Font2_ColorApp = selectedModelSetting.attributes.Font1_Color;
        selectedModelSetting_11.attributes.Font3_App = selectedModelSetting.attributes.Font1;
        selectedModelSetting_11.attributes.Font3_ColorApp = selectedModelSetting.attributes.Font1_Color;
        selectedModelSetting_11.attributes.Font4_App = selectedModelSetting.attributes.Font2;
        selectedModelSetting_11.attributes.Font4_ColorApp = selectedModelSetting.attributes.Font2_Color;

        if (selectedModelSetting_11.attributes.Font1_FontType == "0") {
            selectedModelSetting_11.attributes.Font1_App = selectedModelSetting.attributes.Font1;
            selectedModelSetting_11.attributes.Font1 = selectedModelSetting.attributes.Font1;
        }
        if (selectedModelSetting_11.attributes.Font1_ColorType == "0") {
            selectedModelSetting_11.attributes.Font1_ColorApp = selectedModelSetting.attributes.Font1_Color;
            selectedModelSetting_11.attributes.Font1_Color = selectedModelSetting.attributes.Font1_Color;
        }

        if (selectedModelSetting_11.attributes.Font2_FontType == "0") {
            selectedModelSetting_11.attributes.Font2_App = selectedModelSetting.attributes.Font1;
            selectedModelSetting_11.attributes.Font2 = selectedModelSetting.attributes.Font1;
        }
        if (selectedModelSetting_11.attributes.Font2_ColorType == "0") {
            selectedModelSetting_11.attributes.Font2_ColorApp = selectedModelSetting.attributes.Font1_Color;
            selectedModelSetting_11.attributes.Font2_Color = selectedModelSetting.attributes.Font1_Color;
        }

        if (selectedModelSetting_11.attributes.Font3_FontType == "0") {
            selectedModelSetting_11.attributes.Font3_App = selectedModelSetting.attributes.Font1;
            selectedModelSetting_11.attributes.Font3 = selectedModelSetting.attributes.Font1;
        }
        if (selectedModelSetting_11.attributes.Font3_ColorType == "0") {
            selectedModelSetting_11.attributes.Font3_ColorApp = selectedModelSetting.attributes.Font1_Color;
            selectedModelSetting_11.attributes.Font3_Color = selectedModelSetting.attributes.Font1_Color;
        }

        if (selectedModelSetting_11.attributes.Font4_FontType == "0") {
            selectedModelSetting_11.attributes.Font4_App = selectedModelSetting.attributes.Font2;
            selectedModelSetting_11.attributes.Font4 = selectedModelSetting.attributes.Font2;
        }
        if (selectedModelSetting_11.attributes.Font4_ColorType == "0") {
            selectedModelSetting_11.attributes.Font4_ColorApp = selectedModelSetting.attributes.Font2_Color;
            selectedModelSetting_11.attributes.Font4_Color = selectedModelSetting.attributes.Font2_Color;
        }


        var savedata_11 = [{ Data: selectedModelSetting_11.attributes }];
        var strJson_11 = JSON.stringify(savedata_11);
        app.entities.collections.customModule.where({ EventId: eventId, ModuleType: ModuleType })[0].attributes.Data = strJson_11;
        app.entities.collections.customModule.where({ EventId: eventId, ModuleType: ModuleType })[0].save(app.entities.collections.customModule.where({ EventId: eventId, ModuleType: ModuleType })[0].attributes, {
            silent: false,
            wait: true,
            success: function () {
            }
        });
    },
    updateFontFromApp: function (selectedModelSetting) {
        switch (selectedModelSetting.attributes.SchemaScreen.Font1_FontType) {
            case "0": selectedModelSetting.attributes.SchemaScreen.Font1 = selectedModelSetting.attributes.Font1; break;
            case "3": selectedModelSetting.attributes.SchemaScreen.Font1 = selectedModelSetting.attributes.Font2; break;
        }

        switch (selectedModelSetting.attributes.SchemaScreen.Font2_FontType) {
            case "0": selectedModelSetting.attributes.SchemaScreen.Font2 = selectedModelSetting.attributes.Font1; break;
            case "3": selectedModelSetting.attributes.SchemaScreen.Font2 = selectedModelSetting.attributes.Font2; break;
        }

        switch (selectedModelSetting.attributes.SchemaScreen.Font1_ColorType) {
            case "0": selectedModelSetting.attributes.SchemaScreen.Font1_Color = selectedModelSetting.attributes.Font1_Color; break;
            case "3": selectedModelSetting.attributes.SchemaScreen.Font1_Color = selectedModelSetting.attributes.Font2_Color; break;
        }

        switch (selectedModelSetting.attributes.SchemaScreen.Font2_ColorType) {
            case "0": selectedModelSetting.attributes.SchemaScreen.Font2_Color = selectedModelSetting.attributes.Font1_Color; break;
            case "3": selectedModelSetting.attributes.SchemaScreen.Font2_Color = selectedModelSetting.attributes.Font2_Color; break;
        }

        //
        switch (selectedModelSetting.attributes.Form.Font1_FontType) {
            case "0": selectedModelSetting.attributes.Form.Font1 = selectedModelSetting.attributes.Font1; break;
            case "3": selectedModelSetting.attributes.Form.Font1 = selectedModelSetting.attributes.Font2; break;
        }

        switch (selectedModelSetting.attributes.Form.Font2_FontType) {
            case "0": selectedModelSetting.attributes.Form.Font2 = selectedModelSetting.attributes.Font1; break;
            case "3": selectedModelSetting.attributes.Form.Font2 = selectedModelSetting.attributes.Font2; break;
        }

        switch (selectedModelSetting.attributes.Form.Font1_ColorType) {
            case "0": selectedModelSetting.attributes.Form.Font1_Color = selectedModelSetting.attributes.Font1_Color; break;
            case "3": selectedModelSetting.attributes.Form.Font1_Color = selectedModelSetting.attributes.Font2_Color; break;
        }

        switch (selectedModelSetting.attributes.Form.Font2_ColorType) {
            case "0": selectedModelSetting.attributes.Form.Font2_Color = selectedModelSetting.attributes.Font1_Color; break;
            case "3": selectedModelSetting.attributes.Form.Font2_Color = selectedModelSetting.attributes.Font2_Color; break;
        }

        return selectedModelSetting;
    },
    //updateFontFromApp: function (eventId, app) {
    //    var tmpSelectedModelSetting = app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 100 })[0];
    //    var data = JSON.parse(tmpSelectedModelSetting.attributes.Data);
    //    var selectedModelSetting = new Entities_Memory.Model(data[0].Data);

    //    switch (selectedModelSetting.attributes.SchemaScreen.Font1_FontType) {
    //        case "0": selectedModelSetting.attributes.SchemaScreen.Font1 = selectedModelSetting.attributes.Font1; break;
    //        case "3": selectedModelSetting.attributes.SchemaScreen.Font1 = selectedModelSetting.attributes.Font2; break;
    //    }

    //    switch (selectedModelSetting.attributes.SchemaScreen.Font2_FontType) {
    //        case "0": selectedModelSetting.attributes.SchemaScreen.Font2 = selectedModelSetting.attributes.Font1; break;
    //        case "3": selectedModelSetting.attributes.SchemaScreen.Font2 = selectedModelSetting.attributes.Font2; break;
    //    }

    //    switch (selectedModelSetting.attributes.SchemaScreen.Font1_ColorType) {
    //        case "0": selectedModelSetting.attributes.SchemaScreen.Font1_Color = selectedModelSetting.attributes.Font1_Color; break;
    //        case "3": selectedModelSetting.attributes.SchemaScreen.Font1_Color = selectedModelSetting.attributes.Font2_Color; break;
    //    }

    //    switch (selectedModelSetting.attributes.SchemaScreen.Font2_ColorType) {
    //        case "0": selectedModelSetting.attributes.SchemaScreen.Font2_Color = selectedModelSetting.attributes.Font1_Color; break;
    //        case "3": selectedModelSetting.attributes.SchemaScreen.Font2_Color = selectedModelSetting.attributes.Font2_Color; break;
    //    }

    //    var savedata = [{ Data: selectedModelSetting.attributes }];
    //    var strJson = JSON.stringify(savedata);
    //    app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 100 })[0].attributes.Data = strJson;
    //    app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 100 })[0].save(app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 100 })[0].attributes, {
    //        silent: false,
    //        wait: true,
    //        success: function () {
    //        }
    //    });
    //},
    updateFontFromAppOld: function (eventId, app) {
        var tmpSelectedModelSetting = app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 100 })[0];
        var data = JSON.parse(tmpSelectedModelSetting.attributes.Data);
        var selectedModelSetting = new Entities_Memory.Model(data[0].Data);

        var callback = function () {
        }

        this.updateFontFromAppSetting(selectedModelSetting, eventId, 11);
        this.updateFontFromInfopage(eventId, 1, app, new Entities_Memory.Model(JSON.parse(app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 11 })[0].attributes.Data)[0].Data), callback);
        this.updateFontFromAppSetting(selectedModelSetting, eventId, 12);
        this.updateFontFromInfopage(eventId, 2, app, new Entities_Memory.Model(JSON.parse(app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 12 })[0].attributes.Data)[0].Data), callback);
        this.updateFontFromAppSetting(selectedModelSetting, eventId, 13)
        this.updateFontFromInfopage(eventId, 3, app, new Entities_Memory.Model(JSON.parse(app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 13 })[0].attributes.Data)[0].Data), callback);
        this.updateFontFromAppSetting(selectedModelSetting, eventId, 14);
        this.updateFontFromInfopage(eventId, 4, app, new Entities_Memory.Model(JSON.parse(app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 14 })[0].attributes.Data)[0].Data), callback);
        this.updateFontFromAppSetting(selectedModelSetting, eventId, 15);
        this.updateFontFromInfopage(eventId, 5, app, new Entities_Memory.Model(JSON.parse(app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 15 })[0].attributes.Data)[0].Data), callback);
        this.updateFontFromAppSetting(selectedModelSetting, eventId, 16);
        this.updateFontFromInfopage(eventId, 6, app, new Entities_Memory.Model(JSON.parse(app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 16 })[0].attributes.Data)[0].Data), callback);
        this.updateFontFromAppSetting(selectedModelSetting, eventId, 17);
        this.updateFontFromInfopage(eventId, 7, app, new Entities_Memory.Model(JSON.parse(app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 17 })[0].attributes.Data)[0].Data), callback);
        this.updateFontFromAppSetting(selectedModelSetting, eventId, 18);
        this.updateFontFromInfopage(eventId, 8, app, new Entities_Memory.Model(JSON.parse(app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 18 })[0].attributes.Data)[0].Data), callback);

        //var model = app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 1 })[0];
        //var data = JSON.parse(model.attributes.Data)[0];
        //var collection = new Entities_Memory_Position.Collection(data.Collection);
        //collection.forEach(function (entry) {
        //    var webpage_collection = new Entities_Memory_Position.Collection(entry.attributes.Collection);
        //    webpage_collection.forEach(function (webpage_collection_model) {
        //        if (webpage_collection_model.attributes.Data != undefined) {
        //            if (!jQuery.isEmptyObject(webpage_collection_model.attributes.Data)) {
        //                var model = new Entities_Memory.Model(webpage_collection_model.attributes.Data);

        //                if (model.attributes.Font1_FontType != undefined) {
        //                    switch (model.attributes.Font1_FontType) {
        //                        case "0": model.attributes.Font1 = selectedModelSetting_11.attributes.Font1; break;
        //                        case "1": model.attributes.Font1 = selectedModelSetting_11.attributes.Font2; break;
        //                        case "2": model.attributes.Font1 = selectedModelSetting_11.attributes.Font3; break;
        //                        case "3": model.attributes.Font1 = selectedModelSetting_11.attributes.Font4; break;
        //                    }
        //                }

        //                if (model.attributes.Font2_FontType != undefined) {
        //                    switch (model.attributes.Font2_FontType) {
        //                        case "0": model.attributes.Font2 = selectedModelSetting_11.attributes.Font1; break;
        //                        case "1": model.attributes.Font2 = selectedModelSetting_11.attributes.Font2; break;
        //                        case "2": model.attributes.Font2 = selectedModelSetting_11.attributes.Font3; break;
        //                        case "3": model.attributes.Font2 = selectedModelSetting_11.attributes.Font4; break;
        //                    }
        //                }

        //                if (model.attributes.Font3_FontType != undefined) {
        //                    switch (model.attributes.Font3_FontType) {
        //                        case "0": model.attributes.Font3 = selectedModelSetting_11.attributes.Font1; break;
        //                        case "1": model.attributes.Font3 = selectedModelSetting_11.attributes.Font2; break;
        //                        case "2": model.attributes.Font3 = selectedModelSetting_11.attributes.Font3; break;
        //                        case "3": model.attributes.Font3 = selectedModelSetting_11.attributes.Font4; break;
        //                    }
        //                }

        //                if (model.attributes.Font1_ColorType != undefined) {
        //                    switch (model.attributes.Font1_ColorType) {
        //                        case "0": model.attributes.Font1_Color = selectedModelSetting_11.attributes.Font1_Color; break;
        //                        case "1": model.attributes.Font1_Color = selectedModelSetting_11.attributes.Font2_Color; break;
        //                        case "2": model.attributes.Font1_Color = selectedModelSetting_11.attributes.Font3_Color; break;
        //                        case "3": model.attributes.Font1_Color = selectedModelSetting_11.attributes.Font4_Color; break;
        //                    }
        //                }

        //                if (model.attributes.Font2_ColorType != undefined) {
        //                    switch (model.attributes.Font2_ColorType) {
        //                        case "0": model.attributes.Font2_Color = selectedModelSetting_11.attributes.Font1_Color; break;
        //                        case "1": model.attributes.Font2_Color = selectedModelSetting_11.attributes.Font2_Color; break;
        //                        case "2": model.attributes.Font2_Color = selectedModelSetting_11.attributes.Font3_Color; break;
        //                        case "3": model.attributes.Font2_Color = selectedModelSetting_11.attributes.Font4_Color; break;
        //                    }
        //                }

        //                if (model.attributes.Font3_ColorType != undefined) {
        //                    switch (model.attributes.Font3_ColorType) {
        //                        case "0": model.attributes.Font3_Color = selectedModelSetting_11.attributes.Font1_Color; break;
        //                        case "1": model.attributes.Font3_Color = selectedModelSetting_11.attributes.Font2_Color; break;
        //                        case "2": model.attributes.Font3_Color = selectedModelSetting_11.attributes.Font3_Color; break;
        //                        case "3": model.attributes.Font3_Color = selectedModelSetting_11.attributes.Font4_Color; break;
        //                    }
        //                }

        //                //var savedata_1 = [{ Data: model.attributes }];
        //                //var strJson_1 = JSON.stringify(savedata_1);
        //                //webpage_collection_model.attributes.Data = strJson_1;
        //                webpage_collection_model.attributes.Data = model.attributes;
        //            }
        //        }
        //    });

        //    /*var savedata_collection = [{ Collection: webpage_collection }];
        //    var strJson_collection = JSON.stringify(savedata_collection);
        //    entry.attributes.Collection = strJson_collection;*/
        //    entry.attributes.Collection = webpage_collection;
        //});

        //var data = [{ Collection: collection }];
        //var strJson = JSON.stringify(data);
        //model.attributes.Data = strJson;

        //app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 1 })[0].save(model.attributes, {
        //    silent: true,
        //    wait: true,
        //    success: function () {
        //    }
        //});
    },
    getSelectedFont: function (app, id, font) {
        var ret;
        switch (id) {
            case "0": ret = app.entities.models.InfoPageSetting.attributes.Font1; break;
            case "1": ret = app.entities.models.InfoPageSetting.attributes.Font2; break;
            case "2": ret = app.entities.models.InfoPageSetting.attributes.Font3; break;
            case "3": ret = app.entities.models.InfoPageSetting.attributes.Font4; break;
            case "10": ret = font; break;
        }

        return ret;
    },
    getSelectedFontApp2: function (app, id, font, themeCollectionModel) {
        var ret;
        switch (id) {
            case "0": ret = themeCollectionModel.attributes.Font1; break;
            case "3": ret = themeCollectionModel.attributes.Font2; break;
            case "10": ret = font; break;
        }

        return ret;
    },
    getSelectedFontApp: function (app, id, font, fontApp) {
        var ret;
        switch (id) {
            case "0": ret = fontApp; break;
            case "10": ret = font; break;
        }

        return ret;
    },
    getSelectedColor: function (app, id, color) {
        var ret;
        switch (id) {
            case "0": ret = app.entities.models.InfoPageSetting.attributes.Font1_Color; break;
            case "1": ret = app.entities.models.InfoPageSetting.attributes.Font2_Color; break;
            case "2": ret = app.entities.models.InfoPageSetting.attributes.Font3_Color; break;
            case "3": ret = app.entities.models.InfoPageSetting.attributes.Font4_Color; break;
            case "10": ret = color; break;
        }

        return ret;
    },
    getSelectedColorApp2: function (app, id, color, themeCollectionModel) {
        var ret;
        switch (id) {
            case "0": ret = themeCollectionModel.attributes.Font1_Color; break;
            case "3": ret = themeCollectionModel.attributes.Font2_Color; break;
            case "10": ret = color; break;
        }

        return ret;
    },
    getSelectedColorApp: function (app, id, color, colorApp) {
        var ret;
        switch (id) {
            case "0": ret = colorApp; break;
            case "10": ret = color; break;
        }

        return ret;
    },
    getSelectedFont_enabled: function (id) {
        var ret;
        switch (id) {
            case "0": ret = false; break;
            case "1": ret = false; break;
            case "2": ret = false; break;
            case "3": ret = false; break;
            case "10": ret = true; break;
        }

        return ret;
    },
    getSelectedColor_enabled: function (id) {
        var ret;
        switch (id) {
            case "0": ret = false; break;
            case "1": ret = false; break;
            case "2": ret = false; break;
            case "3": ret = false; break;
            case "10": ret = true; break;
        }

        return ret;
    },
    updateFontFromTheme: function (eventId, app) {
        var tmpSelectedModelSetting = app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 98 })[0];
        var data = JSON.parse(tmpSelectedModelSetting.attributes.Data);

        var themeCollection = new Entities_Memory_Position.Collection(data[0].Data.ThemeCollection);
        var model = themeCollection.where({ id: data[0].Data.ThemeCollectionSelected})[0];

        var callback = function () {
        }

        this.updateFromThemeSetting2Module(model, eventId);
        this.updateFromThemeSetting(model, eventId, 11);
        this.updateFromThemeSetting(model, eventId, 12);
        this.updateFromThemeSetting(model, eventId, 13);
        this.updateFromThemeSetting(model, eventId, 14);
        this.updateFromThemeSetting(model, eventId, 15);
        this.updateFromThemeSetting(model, eventId, 16);
        this.updateFromThemeSetting(model, eventId, 17);
        this.updateFromThemeSetting(model, eventId, 18);

        this.updateFontFromInfopage(eventId, 1, app, new Entities_Memory.Model(JSON.parse(app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 11 })[0].attributes.Data)[0].Data), callback);
        this.updateFontFromInfopage(eventId, 2, app, new Entities_Memory.Model(JSON.parse(app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 12 })[0].attributes.Data)[0].Data), callback);
        this.updateFontFromInfopage(eventId, 3, app, new Entities_Memory.Model(JSON.parse(app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 13 })[0].attributes.Data)[0].Data), callback);
        this.updateFontFromInfopage(eventId, 4, app, new Entities_Memory.Model(JSON.parse(app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 14 })[0].attributes.Data)[0].Data), callback);
        this.updateFontFromInfopage(eventId, 5, app, new Entities_Memory.Model(JSON.parse(app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 15 })[0].attributes.Data)[0].Data), callback);
        this.updateFontFromInfopage(eventId, 6, app, new Entities_Memory.Model(JSON.parse(app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 16 })[0].attributes.Data)[0].Data), callback);
        this.updateFontFromInfopage(eventId, 7, app, new Entities_Memory.Model(JSON.parse(app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 17 })[0].attributes.Data)[0].Data), callback);
        this.updateFontFromInfopage(eventId, 8, app, new Entities_Memory.Model(JSON.parse(app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 18 })[0].attributes.Data)[0].Data), callback);

        this.updateFromThemeSettingApp(model, eventId);

        /*this.updateFontFromInfopage(eventId, 1, app, new Entities_Memory.Model(JSON.parse(app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 11 })[0].attributes.Data)[0].Data), callback);
        this.updateFontFromThemeSetting(selectedModelSetting, eventId, 12);
        this.updateFontFromInfopage(eventId, 2, app, new Entities_Memory.Model(JSON.parse(app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 12 })[0].attributes.Data)[0].Data), callback);
        this.updateFontFromThemeSetting(selectedModelSetting, eventId, 13)
        this.updateFontFromInfopage(eventId, 3, app, new Entities_Memory.Model(JSON.parse(app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 13 })[0].attributes.Data)[0].Data), callback);
        this.updateFontFromThemeSetting(selectedModelSetting, eventId, 14);
        this.updateFontFromInfopage(eventId, 4, app, new Entities_Memory.Model(JSON.parse(app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 14 })[0].attributes.Data)[0].Data), callback);
        this.updateFontFromThemeSetting(selectedModelSetting, eventId, 15);
        this.updateFontFromInfopage(eventId, 5, app, new Entities_Memory.Model(JSON.parse(app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 15 })[0].attributes.Data)[0].Data), callback);
        this.updateFontFromThemeSetting(selectedModelSetting, eventId, 16);
        this.updateFontFromInfopage(eventId, 6, app, new Entities_Memory.Model(JSON.parse(app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 16 })[0].attributes.Data)[0].Data), callback);
        this.updateFontFromThemeSetting(selectedModelSetting, eventId, 17);
        this.updateFontFromInfopage(eventId, 7, app, new Entities_Memory.Model(JSON.parse(app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 17 })[0].attributes.Data)[0].Data), callback);
        this.updateFontFromThemeSetting(selectedModelSetting, eventId, 18);
        this.updateFontFromInfopage(eventId, 8, app, new Entities_Memory.Model(JSON.parse(app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 18 })[0].attributes.Data)[0].Data), callback);*/

        
    },
    updateFromThemeSetting2Module(selectedModelSetting, eventId) {
        var tmpModuleSetting = app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 99 })[0];
        var data = JSON.parse(tmpModuleSetting.attributes.Data);
        var tmpModuleSettingModel = new Entities_Memory.Model(data[0].Data);
        var tmpCollection = new Entities_Memory_Position.Collection(tmpModuleSettingModel.attributes.Collection);

        tmpCollection.forEach(function (entry) {
            //var model = tmpCollection.where({ id: 1 })[0];

            entry.attributes.BackGroundColorApp = selectedModelSetting.attributes.Info_BackGroundColor;
            entry.attributes.BorderColorApp = selectedModelSetting.attributes.Info_ForeGroundColor;
        });

        //model.attributes.BorderColor = selectedModelSetting.attributes.Info_ForeGroundColor;

        tmpModuleSettingModel.attributes.Collection = tmpCollection.toJSON();
        var strJson = JSON.stringify(tmpModuleSettingModel.toJSON());
        tmpModuleSetting.attributes.Data = '[{ "Data" : ' + strJson + '}]';

        tmpModuleSetting.save({ wait: true });

        //Setup 
        app.entities.collections.ModuleSetting = new Backbone.Collection(tmpModuleSettingModel.attributes.Collection);
    },
    updateFromThemeSetting(selectedModelSetting, eventId, ModuleType) {
        var tmpSelectedModelSetting_11 = app.entities.collections.customModule.where({ EventId: eventId, ModuleType: ModuleType })[0];
        var data_11 = JSON.parse(tmpSelectedModelSetting_11.attributes.Data);
        var selectedModelSetting_11 = new Entities_Memory.Model(data_11[0].Data);

        selectedModelSetting_11.attributes.BackGroundColorApp = selectedModelSetting.attributes.Info_BackGroundColor;

        selectedModelSetting_11.attributes.Font1_App = selectedModelSetting.attributes.Info_Font1;
        selectedModelSetting_11.attributes.Font1_ColorApp = selectedModelSetting.attributes.Info_Font1_Color;
        selectedModelSetting_11.attributes.Font2_App = selectedModelSetting.attributes.Info_Font2;
        selectedModelSetting_11.attributes.Font2_ColorApp = selectedModelSetting.attributes.Info_Font2_Color;
        selectedModelSetting_11.attributes.Font3_App = selectedModelSetting.attributes.Info_Font3;
        selectedModelSetting_11.attributes.Font3_ColorApp = selectedModelSetting.attributes.Info_Font3_Color;
        selectedModelSetting_11.attributes.Font4_App = selectedModelSetting.attributes.Info_Font4;
        selectedModelSetting_11.attributes.Font4_ColorApp = selectedModelSetting.attributes.Info_Font4_Color;

        if (selectedModelSetting_11.attributes.Font1_FontType == "0") {
            selectedModelSetting_11.attributes.Font1_App = selectedModelSetting.attributes.Info_Font1;
            selectedModelSetting_11.attributes.Font1 = selectedModelSetting.attributes.Info_Font1;
        }
        if (selectedModelSetting_11.attributes.Font1_ColorType == "0") {
            selectedModelSetting_11.attributes.Font1_ColorApp = selectedModelSetting.attributes.Info_Font1_Color;
            selectedModelSetting_11.attributes.Font1_Color = selectedModelSetting.attributes.Info_Font1_Color;
        }

        if (selectedModelSetting_11.attributes.Font2_FontType == "0") {
            selectedModelSetting_11.attributes.Font2_App = selectedModelSetting.attributes.Info_Font2;
            selectedModelSetting_11.attributes.Font2 = selectedModelSetting.attributes.Info_Font2;
        }
        if (selectedModelSetting_11.attributes.Font2_ColorType == "0") {
            selectedModelSetting_11.attributes.Font2_ColorApp = selectedModelSetting.attributes.Info_Font2_Color;
            selectedModelSetting_11.attributes.Font2_Color = selectedModelSetting.attributes.Info_Font2_Color;
        }

        if (selectedModelSetting_11.attributes.Font3_FontType == "0") {
            selectedModelSetting_11.attributes.Font3_App = selectedModelSetting.attributes.Info_Font3;
            selectedModelSetting_11.attributes.Font3 = selectedModelSetting.attributes.Info_Font3;
        }
        if (selectedModelSetting_11.attributes.Font3_ColorType == "0") {
            selectedModelSetting_11.attributes.Font3_ColorApp = selectedModelSetting.attributes.Info_Font3_Color;
            selectedModelSetting_11.attributes.Font3_Color = selectedModelSetting.attributes.Info_Font3_Color;
        }

        if (selectedModelSetting_11.attributes.Font4_FontType == "0") {
            selectedModelSetting_11.attributes.Font4_App = selectedModelSetting.attributes.Info_Font4;
            selectedModelSetting_11.attributes.Font4 = selectedModelSetting.attributes.Info_Font4;
        }
        if (selectedModelSetting_11.attributes.Font4_ColorType == "0") {
            selectedModelSetting_11.attributes.Font4_ColorApp = selectedModelSetting.attributes.Info_Font4_Color;
            selectedModelSetting_11.attributes.Font4_Color = selectedModelSetting.attributes.Info_Font4_Color;
        }


        var savedata_11 = [{ Data: selectedModelSetting_11.attributes }];
        var strJson_11 = JSON.stringify(savedata_11);
        app.entities.collections.customModule.where({ EventId: eventId, ModuleType: ModuleType })[0].attributes.Data = strJson_11;
        app.entities.collections.customModule.where({ EventId: eventId, ModuleType: ModuleType })[0].save(app.entities.collections.customModule.where({ EventId: eventId, ModuleType: ModuleType })[0].attributes, {
            silent: false,
            wait: true,
            success: function () {
            }
        });
    },
    updateFromThemeSettingApp(selectedModelSetting, eventId) {
        var tmpSelectedModelSetting = app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 100 })[0];
        var data = JSON.parse(tmpSelectedModelSetting.attributes.Data);
        var selectedModelSetting_100 = new Entities_Memory.Model(data[0].Data);

        selectedModelSetting_100.attributes.AppFrame_BackGroundColorApp = selectedModelSetting.attributes.AppFrame_BackGroundColor;
        selectedModelSetting_100.attributes.AppFrame_ForeGroundColorApp = selectedModelSetting.attributes.AppFrame_ForeGroundColor;
        selectedModelSetting_100.attributes.BackGroundColorApp = selectedModelSetting.attributes.BackGroundColorApp;
        selectedModelSetting_100.attributes.MenuColorApp_BackGround = selectedModelSetting.attributes.MenuColorApp_BackGround;
        selectedModelSetting_100.attributes.MenuColorApp_ForeGround = selectedModelSetting.attributes.MenuColorApp_ForeGround;
        selectedModelSetting_100.attributes.MenuColorApp_Font = selectedModelSetting.attributes.MenuColorApp_Font;
        selectedModelSetting_100.attributes.Font1_Theme = selectedModelSetting.attributes.Font1;

        if (selectedModelSetting_100.attributes.Font1_FontType == "0") {
            selectedModelSetting_100.attributes.Font1 = selectedModelSetting.attributes.Font1;
        }

        selectedModelSetting_100.attributes.Font1_ColorTheme = selectedModelSetting.attributes.Font1_Color;
        if (selectedModelSetting_100.attributes.Font1_ColorType == "0") {
            selectedModelSetting_100.attributes.Font1_Color = selectedModelSetting.attributes.Font1_Color;
        }

        selectedModelSetting_100.attributes.Font2_Theme = selectedModelSetting.attributes.Font2;
        if (selectedModelSetting_100.attributes.Font2_FontType == "0") {
            selectedModelSetting_100.attributes.Font2 = selectedModelSetting.attributes.Font2;
        }

        selectedModelSetting_100.attributes.Font2_ColorTheme = selectedModelSetting.attributes.Font2_Color;
        if (selectedModelSetting_100.attributes.Font2_ColorType == "0") {
            selectedModelSetting_100.attributes.Font2_Color = selectedModelSetting.attributes.Font2_Color;
        }

        switch (selectedModelSetting_100.attributes.SchemaScreen.Font1_FontType) {
            case "0": selectedModelSetting_100.attributes.SchemaScreen.Font1 = selectedModelSetting.attributes.Font1; break;
            case "3": selectedModelSetting_100.attributes.SchemaScreen.Font1 = selectedModelSetting.attributes.Font2; break;
        }

        switch (selectedModelSetting_100.attributes.SchemaScreen.Font2_FontType) {
            case "0": selectedModelSetting_100.attributes.SchemaScreen.Font2 = selectedModelSetting.attributes.Font1; break;
            case "3": selectedModelSetting_100.attributes.SchemaScreen.Font2 = selectedModelSetting.attributes.Font2; break;
        }

        switch (selectedModelSetting_100.attributes.SchemaScreen.Font1_ColorType) {
            case "0": selectedModelSetting_100.attributes.SchemaScreen.Font1_Color = selectedModelSetting.attributes.Font1_Color; break;
            case "3": selectedModelSetting_100.attributes.SchemaScreen.Font1_Color = selectedModelSetting.attributes.Font2_Color; break;
        }

        switch (selectedModelSetting_100.attributes.SchemaScreen.Font2_ColorType) {
            case "0": selectedModelSetting_100.attributes.SchemaScreen.Font2_Color = selectedModelSetting.attributes.Font1_Color; break;
            case "3": selectedModelSetting_100.attributes.SchemaScreen.Font2_Color = selectedModelSetting.attributes.Font2_Color; break;
        }

        //
        switch (selectedModelSetting_100.attributes.Form.Font1_FontType) {
            case "0": selectedModelSetting_100.attributes.Form.Font1 = selectedModelSetting.attributes.Font1; break;
            case "3": selectedModelSetting_100.attributes.Form.Font1 = selectedModelSetting.attributes.Font2; break;
        }

        switch (selectedModelSetting_100.attributes.Form.Font2_FontType) {
            case "0": selectedModelSetting_100.attributes.Form.Font2 = selectedModelSetting.attributes.Font1; break;
            case "3": selectedModelSetting_100.attributes.Form.Font2 = selectedModelSetting.attributes.Font2; break;
        }

        switch (selectedModelSetting_100.attributes.Form.Font1_ColorType) {
            case "0": selectedModelSetting_100.attributes.Form.Font1_Color = selectedModelSetting.attributes.Font1_Color; break;
            case "3": selectedModelSetting_100.attributes.Form.Font1_Color = selectedModelSetting.attributes.Font2_Color; break;
        }

        switch (selectedModelSetting_100.attributes.Form.Font2_ColorType) {
            case "0": selectedModelSetting_100.attributes.Form.Font2_Color = selectedModelSetting.attributes.Font1_Color; break;
            case "3": selectedModelSetting_100.attributes.Form.Font2_Color = selectedModelSetting.attributes.Font2_Color; break;
        }

        var savedata = [{ Data: selectedModelSetting_100.attributes }];
        var strJson = JSON.stringify(savedata);
        app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 100 })[0].attributes.Data = strJson;
        app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 100 })[0].save(app.entities.collections.customModule.where({ EventId: eventId, ModuleType: 100 })[0].attributes, {
            silent: false,
            wait: true,
            success: function () {
            }
        });
    },
}

export default HelperInfopage;